/* eslint-disable react/prop-types */
import { Avatar, Grid, Stack } from '@mui/material';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import { useEffect, useRef, useState } from 'react';
import { synthesizeTextToSpeech } from "../service/gplx.speech.service";

const AudioPlayer = ({ text, index = "" }) => {
  const [voiceName, setVoiceName] = useState('male');
  const playerRef = useRef(null);

  useEffect(() => {
    const player = new Plyr(`#player-${index}`, {
      speed: {
        selected: 1, options: [0.25, 0.5, 1, 1.25, 1.5],
      },
    });
    playerRef.current = player;

    player.on('play', () => {
      if (!player.source)
        fetchAudio(voiceName);
    });

    return () => {
      player.destroy();
    };
  }, [text, index]);

  const fetchAudio = async (voiceName) => {
    const audioUrl = await synthesizeTextToSpeech(text, voiceName);
    if (audioUrl) {
      playerRef.current.source = {
        type: 'audio',
        sources: [
          {
            src: audioUrl,
            type: 'audio/mp3'
          }
        ]
      };
      playerRef.current.play();
    }
  };

  const changeVoice = (name) => {
    if (name !== voiceName) {
      setVoiceName(name);
      fetchAudio(name);
    }
  };

  return (
    <Grid container>
      <Grid item>
        <Stack direction="row" spacing={2} my={1} alignItems={"center"}>
          <Avatar
            alt="male"
            src="/img/male.jpg"
            onClick={() => changeVoice('male')}
            sx={{
              border: voiceName === 'male' ? '2px solid blue' : 'none',
              cursor: 'pointer',
              width: 30,
              height: 30
            }}
          />
          <Avatar
            alt="female"
            src="/img/female.jpg"
            onClick={() => changeVoice('female')}
            sx={{
              border: voiceName === 'female' ? '2px solid blue' : 'none',
              width: 30,
              height: 30,
              cursor: 'pointer',
            }}
          />
          <audio id={`player-${index}`} className="plyr" controls  >
            Your browser does not support the audio element.
          </audio>
        </Stack>
      </Grid>
    </Grid >
  );
};

export default AudioPlayer;